module.exports = __webpack_public_path__ + "img/1440.16e70925.jpg";